import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";

const initialState: State = [];

function handleRequest(
  state: State,
  { list }: Boundaries["duplicateList"]["request"],
): State {
  const index = state.findIndex((req) => req.list.uuid === list.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { list, request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { list, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { list }: Boundaries["duplicateList"]["success"],
): State {
  const index = state.findIndex((req) => req.list.uuid === list.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { list, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { list, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { list }: Boundaries["duplicateList"]["failure"],
): State {
  const index = state.findIndex((req) => req.list.uuid === list.uuid);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { list, request: setRequestStateToFailure() },
        ...state.slice(index + 1),
      ]
    : [...state, { list, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.duplicateListRequested]: handleRequest,
    [events.duplicateListSucceeded]: handleSuccess,
    [events.duplicateListFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
